// Fake appointment/timeblock ids in the negatives to not conflict with real appointments
export const APPOINTMENT_PROMO_NEW_CLIENT_DELIVERY_ID = -1;
export const APPOINTMENT_PROMO_SMART_PRICING_ID = -2;
export const APPOINTMENT_PROMO_LAST_MINUTE_CANCELLATION_ID = -3;

// Keys for stateManager to manage one time interaction for appointment promos
export const APPOINTMENT_PROMO_NEW_CLIENT_DELIVERY_NAME = 'appointment_promo_new_client_delivery';
export const APPOINTMENT_PROMO_SMART_PRICING_NAME = 'appointment_promo_smart_pricing';
export const APPOINTMENT_PROMO_LAST_MINUTE_CANCELLATION_NAME = 'appointment_promo_last_minute_cancellation';
